import { useEffect, useRef, useState } from "react";

const RESULTADO_VACIO = {
    detalleFiltrado: [],
    datosGraficaFamilias: [],
    datosGraficaClientes: [],
    datosGraficaVendedores: [],
    paretoClientesPorAnio: [],
    familiasDelGrupoPareto: [],
    kpisCalculados: { totalGeneral: 0, clientesTotales: 0, familiasTotales: 0 },
};

// Corre el pipeline pesado de ReporteRefaccionesBoceto.js (filtro de
// sidebar + agrupaciones + Pareto + KPIs) en un Web Worker
// (reporteRefaccionesCalculosWorker.js), para no bloquear el hilo
// principal cuando `detalle` crece. Reemplaza la cadena de `useMemo` que
// antes calculaba todo esto de forma síncrona en el componente. Detalle
// completo (qué dispara un recálculo, impacto en los filtros, cómo
// extenderlo) en el README de este módulo.
export const useReporteRefaccionesCalculos = ({
    detalle,
    sidebarFiltros,
    grupoParetoSeleccionado,
    metricaFamiliasPareto,
    aniosComparativos,
    anioPrincipal,
}) => {
    const workerRef = useRef(null);
    const requestIdRef = useRef(0);
    const [resultado, setResultado] = useState(RESULTADO_VACIO);
    const [calculando, setCalculando] = useState(false);

    // Un solo worker por instancia de la pantalla; se destruye al desmontar.
    useEffect(() => {
        workerRef.current = new Worker(
            new URL("./reporteRefaccionesCalculosWorker.js", import.meta.url)
        );
        return () => workerRef.current.terminate();
    }, []);

    // Cualquier cambio en estos 6 valores dispara un recálculo (sidebar,
    // grupo/métrica del Pareto de Familias, o `detalle` mismo al cargar/
    // restaurar). `requestId` descarta respuestas de peticiones viejas si
    // el usuario cambia el filtro varias veces antes de que la primera
    // responda (evita que una respuesta tardía pise a una más reciente).
    useEffect(() => {
        const worker = workerRef.current;
        if (!worker) return;

        const requestId = ++requestIdRef.current;
        setCalculando(true);

        const onMessage = (event) => {
            if (event.data.requestId !== requestIdRef.current) return;
            setResultado(event.data);
            setCalculando(false);
        };

        worker.addEventListener("message", onMessage);
        worker.postMessage({
            requestId,
            detalle,
            sidebarFiltros,
            grupoParetoSeleccionado,
            metricaFamiliasPareto,
            aniosComparativos,
            anioPrincipal,
        });

        return () => worker.removeEventListener("message", onMessage);
    }, [detalle, sidebarFiltros, grupoParetoSeleccionado, metricaFamiliasPareto, aniosComparativos, anioPrincipal]);

    return { ...resultado, calculando };
};
